export default [
    {
        path: 'my-interactions',
        name: 'my-interactions',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_interactions').ucFirst();
            },
        },
        component: () => import('@/views/pages/interactions/interactions/own.vue')
    },
    {
        path: 'my-meetings',
        name: 'interactions-my-meetings',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_meetings').ucFirst();
            },
        },
        component: () => import('@/views/pages/meetings/own.vue'),
        redirect: { name: 'interactions-my-meetings-list' },
        children: [
            {
                path: '',
                name: 'interactions-my-meetings-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_meetings').ucFirst();
                    },
                },
                component: () => import('@/views/pages/meetings/own.vue')
            },
            {
                path: 'create',
                name: 'interactions-my-meeting-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.my_meetings', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/meetings/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-my-meeting-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.my_meetings', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/meetings/item.vue'),
                props: { own: true, interaction: true },
            },
        ]
    }
]